import React from 'react';
import PropTypes from 'prop-types';
import { Col, FormGroup, ControlLabel, HelpBlock, FormControl, InputGroup } from 'react-bootstrap';

const Input = ({ horizontal, icon, required, input, labelCol = 3, valueCol = 9, label, type, help, meta: { touched, error, warning }, children, ...props }) => {
	const validationState = touched && (error && "error") || (warning && "warning") || null;

	let formControl = <FormControl {...input} type={type} {...props}>{children}</FormControl>;
	if (icon) {
		formControl = <InputGroup><InputGroup.Addon><i className={icon} /></InputGroup.Addon>{formControl}</InputGroup>;
	}
	const errorBlock = touched && (error || warning) && <HelpBlock>{error || warning}</HelpBlock>;
	const helpBlock = help && <HelpBlock>{help}</HelpBlock>;
	const labelHint = required && <em style={{ color: '#D62229' }}>*</em>;

	if (horizontal) {
		return (
			<FormGroup validationState={validationState} className='row'>
				<Col componentClass={ControlLabel} sm={labelCol}>
					{label}{labelHint}
				</Col>
				<Col sm={valueCol}>
					{formControl}
					{errorBlock}
					{helpBlock}
				</Col>
			</FormGroup>);
	}

	return (
		<FormGroup validationState={validationState}>
			<ControlLabel>{label}{labelHint}</ControlLabel>
			{formControl}
			{errorBlock}
			{helpBlock}
		</FormGroup>
	);
};

Input.propTypes = {
	horizontal: PropTypes.bool,
	input: PropTypes.object,
	label: PropTypes.string,
	type: PropTypes.string,
	help: PropTypes.string,
	meta: PropTypes.object,
	placeholder: PropTypes.string,
	disabled: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	componentClass: PropTypes.string,
	value: PropTypes.string,
	icon: PropTypes.string,
};

export default Input;